// This file is only a template for constants.  Copy and paste this to your application's constants .ts file and start off from there
// Rename all things with App_Name.
// Naming convention for constants is "[App Name]Constants.ts" i.e. UsersConstants.ts, EntitlementConstants.ts

// convention for constants is
// [App_Name]_[Action]
var UserLocaleConstants: IUserLocaleConstants = {
    LOCALE_DISPATCHER: 'LOCALE_DISPATCHER',
    LOCALE_GET: 'LOCALE_GET',
    LOCALE_UPDATE: 'LOCALE_UPDATE',
    LOCALE_PREFERENCES_UPDATE: 'LOCALE_UPDATE',
    UPDATE_LOCALE_SUCCESS: 'UPDATE_LOCALE_SUCCESS',
    LOCALE_VALIDATION_ERROR: 'LOCALE_VALIDATION_ERROR',
    LOCALE_CANCEL_CHANGES: 'LOCALE_CANCEL_CHANGES',
    LOCALE_MAIN_PAGE: 'LOCALE_MAIN_PAGE'
} as const;

export default UserLocaleConstants;